import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Building, ArrowRight } from 'lucide-react';

interface CompanySelectedViewProps {
  companyName: string;
  productsCount: number;
}

const CompanySelectedView: React.FC<CompanySelectedViewProps> = ({ companyName, productsCount }) => {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <Card className="border-2 border-blue-200 dark:border-blue-800">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            <div className="flex items-center justify-center mb-4">
              <Building className="h-16 w-16 text-blue-500" />
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                {companyName}
              </h2>
              <p className="text-gray-600 dark:text-gray-400 text-lg">
                Company Selected
              </p>
            </div>
            
            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6 max-w-md mx-auto">
              <div className="flex items-center justify-center mb-3">
                <ArrowRight className="h-6 w-6 text-blue-600 dark:text-blue-400 mr-2" />
                <span className="text-blue-900 dark:text-blue-100 font-medium">
                  Next Step
                </span>
              </div>
              
              <p className="text-blue-800 dark:text-blue-200 text-center">
                Please select a product (ASIN) from the dropdown to view index checking data.
              </p>
              
              <div className="mt-4 text-sm text-blue-700 dark:text-blue-300 text-center">
                {productsCount} product{productsCount !== 1 ? 's' : ''} available in this company
              </div>
            </div>
            
            <div className="text-sm text-gray-500 dark:text-gray-400">
              <p>You can also:</p>
              <ul className="mt-2 space-y-1">
                <li>• Use the "Paste ASIN" field to quickly find and select a product</li>
                <li>• Click the "Index Checker" header to return to the dashboard view</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompanySelectedView;